import React from 'react';
import ReactDOM from 'react-dom';
import { store } from './services/configureStore';
import App from './app/App';
import './index.css';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(new URL('./serviceWorker.js', import.meta.url));
  });
}

ReactDOM.render(<App store={store} />, document.getElementById('root'));
